/**
 * 获取高拍仪、扫描仪图片并上传
 */
import { get, post } from './http'
import { pgMessage } from '../components/index'
export async function getImageByScan({ url = '/api/camera/file', param, catalogCode, second }) {
  const protocol = !second ? window.location.protocol : second
  const [res, error] = await get(
    `${protocol}//localhost:${protocol === 'http:' ? '7700' : '7701'}${url}`,
    param,
    { errorTip: null, responseType: 'blob' },
    (resData, res) => {
      const disposition = res.headers['content-disposition']
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      const matches = filenameRegex.exec(disposition)
      const filename = matches != null && matches[1] ? matches[1].replace(/['"]/g, '') : 'file.png'
      return {
        code: 200,
        data: {
          file: resData,
          name: filename,
        },
      }
    }
  )
  if (!second && error) {
    return getImageByScan({
      url,
      param,
      second: protocol === 'http:' ? 'https:' : 'http:',
    })
  }
  if (error) {
    pgMessage.error(
      error?.msg?.config && !error?.msg?.response ? '接口无响应，请检查服务是否启动' : error?.msg
    )
    return Promise.reject()
  }

  //开始上传图片
  const formData = new FormData()
  const file = new window.File([res.data.file], res.data.name, { type: res.data.file.type })
  formData.append('file', file)
  formData.append('catalogCode', catalogCode)

  const [uploadRes, uploadError] = await post('rest/ezcomp/file/uploadFile', formData)
  if (uploadError) {
    return Promise.reject()
  }
  return uploadRes
}
